module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"message":"Submit an application for a refund from your blocked VISA cards.","Подать заявление":"Submit the application"},"ru":{"message":"Оформите заявление на возврат средств с ваших заблокированных карт VISA."}}')
  delete Component.options._Ctor
}
